import { FC } from "react";
import { TableBody, TableRow, TableCell, Typography } from "@mui/material";

export const CollectionsTableLoadingState: FC = () => {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={5} align="center">
          <Typography variant="body2" color="text.secondary">
            Loading collections...
          </Typography>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
